import { Formik } from 'formik'
import { KeyboardEvent, ReactElement } from 'react'
import styled from 'styled-components'

import { Input } from 'components/Input'
import { ClickAwayListener } from 'components/v2/ClickAwayListener'
import { IRouteNameFormValues } from 'features/RoutingProjects/types'
import { schema } from './schema'
import { useIntl } from 'react-intl'

const FormContainer = styled.div`
  /* Prevent click events from bubbling to parent */
`

const SubmitButton = styled.button`
  display: none;
`

interface IRouteNameFormProps {
  routeName: string
  onClickAway: () => void
  onSubmit: (routeName: string) => void
}

export const RouteNameForm = ({ routeName, onClickAway, onSubmit }: IRouteNameFormProps): ReactElement => {
  const intl = useIntl()
  const initialValues: IRouteNameFormValues = {
    name: routeName
  }

  const handleSubmit = (values: IRouteNameFormValues): void => {
    if (values.name.trim() === initialValues.name) {
      onClickAway()
      return
    }
    onSubmit(values.name.trim())
  }

  const handleFormClick = (event: React.MouseEvent<HTMLDivElement>): void => {
    event.stopPropagation()
  }

  return (
    <FormContainer onClick={handleFormClick}>
      <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={schema(intl)}>
        {({ values, handleChange, handleSubmit, touched, errors }): ReactElement => {
          const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>): void => {
            if (event.key === 'Escape') {
              onClickAway()
            }
          }

          const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
            event.stopPropagation()
            handleSubmit(event)
          }

          return (
            <form onSubmit={handleFormSubmit}>
              <ClickAwayListener onClickAway={onClickAway}>
                <Input
                  id="name"
                  placeholder="Enter route name"
                  value={values.name}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                  errors={errors.name}
                  touched={touched.name}
                  small
                  autoFocus
                />
              </ClickAwayListener>
              <SubmitButton type="submit"></SubmitButton>
            </form>
          )
        }}
      </Formik>
    </FormContainer>
  )
}
